import React from 'react';
import { motion } from 'framer-motion';
import { HammerIcon, WrenchIcon } from './icons';
export function ServicePresentation() {
  const remodelacion = [{
    name: 'Fences',
    desc: 'Instalación, reparación, reemplazo — madera, metal, vinilo'
  }, {
    name: 'Masonry',
    desc: 'Paredes de bloque, ladrillo, bases de concreto'
  }, {
    name: 'Roofing',
    desc: 'Instalación, reparación y reemplazo de techos'
  }, {
    name: 'Painting',
    desc: 'Interior y exterior, acabados profesionales'
  }, {
    name: 'Drywall',
    desc: 'Instalación, reparación, textura y acabados'
  }, {
    name: 'Floors',
    desc: 'Instalación de pisos — madera, cerámica, vinilo, laminado'
  }, {
    name: 'Windows',
    desc: 'Instalación y reemplazo de ventanas'
  }];
  const restauracion = [{
    name: 'Concreto',
    desc: 'Reparación de grietas, sellado, restauración estructural'
  }, {
    name: 'Ladrillo',
    desc: 'Tuckpointing, reemplazo de ladrillos, limpieza'
  }, {
    name: 'Fence',
    desc: 'Restauración de cercas dañadas o deterioradas'
  }, {
    name: 'Patio',
    desc: 'Restauración completa de patios y áreas exteriores'
  }, {
    name: 'Commercial Cooking',
    desc: 'Restauración de áreas de cocina comercial'
  }, {
    name: 'Power Washing',
    desc: 'Limpieza a presión de superficies, fachadas, patios y entradas'
  }];
  return <section id="servicios" className="py-12 bg-brand-bg-light" data-id="element-255">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-257">
          <div className="text-center mb-8" data-id="element-258">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-white mb-4 tracking-wide" data-id="element-259">
              BENITEZ HANDYMAN CONSTRUCTION
            </h2>
            <p className="text-xl sm:text-2xl text-brand-gold font-medium mb-2" data-id="element-260">
              Ubicados en New Carrollton / Hyattsville, MD
            </p>
            <p className="text-lg text-gray-400" data-id="element-261">
              Sirviendo Maryland, Washington DC, y Virginia
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-6" data-id="element-262">
            {/* Remodelación */}
            <motion.div initial={{
            opacity: 0,
            x: -40
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} className="bg-brand-bg-dark rounded-2xl border border-brand-green/30 overflow-hidden shadow-xl shimmer-border shimmer-border-green" data-id="element-263">
              <div className="bg-brand-green-dark p-6 flex items-center justify-center gap-4 border-b border-brand-green" data-id="element-264">
                <HammerIcon className="w-8 h-8 text-white" data-id="element-265" />
                <h3 className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-266">
                  SERVICIOS DE REMODELACIÓN
                </h3>
              </div>
              <div className="p-0" data-id="element-267">
                <table className="w-full text-left border-collapse" data-id="element-268">
                  <tbody data-id="element-269">
                    {remodelacion.map((item, index) => <motion.tr key={index} initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.4,
                    delay: index * 0.08
                  }} className="border-b border-gray-800 hover:bg-white/5 transition-colors" data-id="element-270">
                        <td className="py-4 px-6 font-heading font-bold text-brand-gold text-lg w-1/3 align-top" data-id="element-271">
                          {item.name}
                        </td>
                        <td className="py-4 px-6 text-gray-300" data-id="element-272">{item.desc}</td>
                      </motion.tr>)}
                  </tbody>
                </table>
              </div>
            </motion.div>

            {/* Restauración */}
            <motion.div initial={{
            opacity: 0,
            x: 40
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.7,
            ease: 'easeOut',
            delay: 0.2
          }} className="bg-brand-bg-dark rounded-2xl border border-brand-gold/30 overflow-hidden shadow-xl shimmer-border" data-id="element-273">
              <div className="bg-brand-gold-dark p-6 flex items-center justify-center gap-4 border-b border-brand-gold" data-id="element-274">
                <WrenchIcon className="w-8 h-8 text-white" data-id="element-275" />
                <h3 className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-276">
                  SERVICIOS DE RESTAURACIÓN
                </h3>
              </div>
              <div className="p-0" data-id="element-277">
                <table className="w-full text-left border-collapse" data-id="element-278">
                  <tbody data-id="element-279">
                    {restauracion.map((item, index) => <motion.tr key={index} initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.4,
                    delay: index * 0.08
                  }} className="border-b border-gray-800 hover:bg-white/5 transition-colors" data-id="element-280">
                        <td className="py-4 px-6 font-heading font-bold text-brand-gold text-lg w-1/3 align-top" data-id="element-281">
                          {item.name}
                        </td>
                        <td className="py-4 px-6 text-gray-300" data-id="element-282">{item.desc}</td>
                      </motion.tr>)}
                  </tbody>
                </table>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}